<template>
    <div>
        <Card class="layout-card" style="height: 100%;">
            <div class="toolbar" >
                <Row :gutter="20">
                    <Col :span="20">
                    <Row :gutter="20">
                        <Col :span="6">
                        <Select v-model="searchForm.userType" placeholder="请选择用户类型" clearable>
                            <Option v-for="(item,index) in userTypeLi" :key="index" :value="item.dictValue">{{ item.dictName }}</Option>
                        </Select>
                        </Col>
                        <Col :span="6">
                        <Select v-model="searchForm.vipStatus" placeholder="请选择是否VIP" clearable>
                            <Option :value="1">是</Option>
                            <Option :value="0">否</Option>
                        </Select>
                        </Col>
                        <!-- <Col :span="6">
                        <Select v-model="searchForm.audio" placeholder="请选择注册媒体" clearable>
                            <Option value="Google">Google</Option>
                            <Option value="Apple">Apple</Option>
                            <Option value="Facebook">Facebook</Option>
                        </Select>
                        </Col> -->
                        <Col :span="6">
                        <Input :maxlength="100" v-model="searchForm.userId" placeholder="请输入用户ID" />
                        </Col>
                        <Col :span="6">
                        <Input :maxlength="100" v-model="searchForm.userNickName" placeholder="请输入用户昵称" />
                        </Col>
                        <Col :span="6">
                        <DatePicker :editable="false" :value="listDate" style="width:100%" format="yyyy-MM-dd HH:mm:ss" type="datetimerange" placeholder="请选择注册时间" @on-change="getListDate"></DatePicker>
                        </Col>
                        <Col :span="6">
                        <Select v-model="searchForm.langId" placeholder="请选择语言" clearable>
                          <Option v-for="(item,index) in langList" :key="index" :value="item.id">{{ item.chineseLangName }}</Option>
                        </Select>
                        </Col>
                        <Col :span="6">
                        <Select v-model="searchForm.colorationType" placeholder="请选择染色类型" clearable>
                          <Option :value="0">默认</Option>
                          <Option :value="1">首次染色</Option>
                          <Option :value="2">重染色</Option>
                          <Option :value="3">自然量</Option>
                        </Select>
                        </Col>
                        <Col :span="6">                        
                        <DatePicker :editable="false" :value="listDate1" style="width:100%" format="yyyy-MM-dd HH:mm:ss" type="datetimerange" placeholder="请选择染色时间" @on-change="getListDate1"></DatePicker>
                        </Col>
                        <Col :span="6">                        
                        <DatePicker :editable="false" :value="listDate2" style="width:100%" format="yyyy-MM-dd HH:mm:ss" type="datetimerange" placeholder="请选择付费时间" @on-change="getListDate2"></DatePicker>
                        </Col>
                        <Col :span="12">
                          <Select v-model="campaign" placeholder="请选择广告系列" filterable :max-tag-count="1" multiple
                          :disabled="!searchOptions.campaign.length"
                          @on-change="searchForm.campaignIdList = $event">
                          <template #prefix>
                              <a v-show="searchOptions.campaign.length"
                                  style="font-size: 12px;padding: 0 5px;white-space:nowrap" @click="(e) => {
                                      e.preventDefault()
                                      e.stopPropagation();
                                      if (campaign.length === searchOptions.campaign.length) {
                                          searchForm.campaignIdList = []
                                          campaign = []
                                      }
                                      else {
                                          const data = [...searchOptions.campaign.map(i=>i.campaignId)]
                                          $set(searchForm, 'campaignIdList', data)
                                          campaign = data
                                      }

                                  }">{{ campaign.length !== searchOptions.campaign.length ? '全选' : '清空' }}</a>
                          </template>
                          <Option v-for="(i, index) in searchOptions.campaign" :key="index" :value="i.campaignId">{{ i.campaignName }}</Option>
                      </Select>
                        </Col>
                    </Row>
                    </Col>
                    <Col :span="4">
                        <Row>
                            <Col><Button type="primary" style="width: 100%" v-if="buttonMenu['/user-info/view']" @click="findData()">查询</Button></Col>
                        </Row>
                        <Row>
                            <Col><Button style="width: 100%" @click="searchForm={};listDate=[];listDate1=[];listDate2=[];campaign=[]">重置</Button></Col>
                        </Row>
                        <Row>
                            <Col><Button type="warning" style="width: 100%" @click="handleExport()">导出</Button></Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            <div style="height: 100%;overflow:auto">
            <Table :columns="column" :data="tableData" :loading="loading">
                <template #canLogin="{row}">
                    <div>
                        <i-switch v-if="buttonMenu['/user-info/enabled']" :value="!row.isEnabled" :before-change="()=>handleChangeStatus(row)"></i-switch>
                        <span v-else>{{ !row.isEnabled?"是":'否' }}</span>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="action">
                    <div>
                        <a v-if="buttonMenu['/user-info/info']" @click="handleOpenModal(row)">详情</a>
                    </div>
                </template>
            <Pages slot="footer" :page="page" :func="findData"></Pages>

            </Table>
            </div>

        </Card>
        <Modal v-model="visible" fullscreen title="用户信息详情" footer-hide>
            <Information v-if="visible" :userData="userForm"></Information>
        </Modal>
    </div>
</template>

<script>
import Information from './components/information'
import Pages from '@/components/pages'
import { getDictionaryList } from '@/api/dictionary'
import { getUserList, changeUserStatus, exportUserList } from '@/api/user'
import { getCampainInit } from '@/api/data'
import { getLangList } from '../../api/lang';
export default {
  components: {
    Information,
    Pages
  },
  data() {
    return {
      listDate: [],
      listDate1: [],
      listDate2: [],
      visible:false,
      searchForm:{},
      userForm: {},
      loading: false,
      page:{
        current: 1,
        size: 10,
        total: 0
      },
      userTypeLi:[],
      form: {
        date: []
      },
      langList:[],
      column:[
        {
          title: '用户id',
          width: 120,
          key: 'userId'
        },
        {
          title: '用户昵称',
          width: 120,
          key: 'userNickName'
        },
        {
          key: 'campaignName',
          title: '用户来源',
          tooltip: true,
          tooltipMaxWidth: 500,
          width: 200
        },
        {
          key: 'userTypeName',
          title: '用户类型',
          width: 100
        },
        
        {
          key: 'thirdAccount',
          width: 120,
          title: '第三方账号'
        },
        {
          key: 'deviceSysName',
          title: 'OS',
          width: 80,
        },
        {
          key: 'langName',
          width: 100,
          title: '使用语言'
        },
        {
          key: 'createTime',
          width: 100,
          title: '注册时间'
        },
        {
          key: 'colorationTypeName',
          width: 100,
          title: '染色类型'
        },
        {
          key: 'colorationTime',
          width: 100,
          title: '染色时间'
        },
        
        {
          key: 'lastLoginTime',
          title: '最后登录时间',
          width: 120
        },
        {
          key: 'lastPaymentTime',
          title: '最近付费',
          width: 120
        },
        {
          key: 'vipStatusName',
          title: '是否VIP',
          width: 80
        },
        {
          key: 'accountBalance',
          width: 100,
          title: '账户余额'
        },

        {
          key: 'lastColorationAccumulatePaymentCount',
          width: 100,
          title: '付费次数'
        },
        {
          key: 'lastColorationAccumulatePayment',
          width: 150,
          title: '最近染色后总付费'
        },
        {
          key: 'country',
          width: 100,
          title: '国家'
        },
        {
          key: 'rechargeTemplate',
          width: 100,
          title: '充值模板'
        },
        
        {
          title: '限制登录',
          width: 90,
          slot: 'canLogin'
        },
        {
          key: 'eventUrl',
          tooltip: true,
          tooltipMaxWidth: 500,
          width: 200,
          title: '推广链',
          render: (h,params)=>{
            return <div>
                {params.row.eventUrl?
                  <Tooltip content={params.row.eventUrl} transfer max-width="200">
                      <a href={params.row.eventUrl} target='_blank' style="white-space:nowrap;overflow:hidden;display:inline-block;width:164px;overflow:hidden;text-overflow:ellipsis">{params.row.eventUrl}</a>
                    </Tooltip>
                  :"-"}
              </div>
          }
        },
        {
          title: '操作',
          width: 100,
          fixed: 'right',
          slot: 'action'
        }
      ],
      searchOptions: {
        campaign: []
      },
      campaign: [],
      tableData: []
    }
  },
  computed:{
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('user/user-info')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods:{
    handleOpenModal(row) {
      this.userForm = row
      this.visible = true
    },
    handleExport(){
        exportUserList({
          ...this.searchForm,
          campaignIdList: this.searchForm.campaignIdList && this.searchForm.campaignIdList.length ? [...this.searchForm.campaignIdList].map(i => i.split(',')[0]) : []
        }).then(r=>{
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = r.data.fileUrl
          // link.href = window.location.origin + r.data.fileUrl.substring(r.data.fileUrl.indexOf('/s_excel'),r.data.fileUrl.length)
          link.setAttribute('download', r.data.fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
    },
    handleGetLang() {
      getLangList({ current: -1, size: -1, langStatus: true }).then(r => {
        this.langList = r.data.records
      })
    },
    handleChangeStatus(row) {
      changeUserStatus(row.id).then(r => {
        this.$Message.success('操作成功')
        this.findData(this.page.current)
      }).catch(e => {
        this.$Message.error('操作失败')
      })
      return new Promise(() => {})
    },
    handleGetUserType() {
      getDictionaryList({ current:-1, size:-1, dictTopic:'USER_TYPE' }).then(r => {
        this.userTypeLi = r.data.records
      })
    },
    getListDate(data) {
      this.listDate = data
      this.searchForm.startDate = data[0]
      this.searchForm.endDate = data[1]
    },
    getListDate1(data) {
      this.listDate1 = data
      this.searchForm.colorationStartDate = data[0]
      this.searchForm.colorationEndDate = data[1]
    },
    getListDate2(data) {
      this.listDate2 = data
      this.searchForm.paymentStartDate = data[0]
      this.searchForm.paymentEndDate = data[1]
    },
    handleGetDataInit() {
            getCampainInit({current:1,size: 1000000}).then(r => {
                this.searchOptions.campaign = r.data.records

            })
        },
    findData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      this.loading = true
      getUserList({
        ...this.page,
        ...this.searchForm,
        campaignIdList: this.searchForm.campaignIdList && this.searchForm.campaignIdList.length ? [...this.searchForm.campaignIdList].map(i => i.split(',')[0]) : []
      }).then(r => {
        if (r.data) {
          this.tableData = r.data.records
        } else this.tableData = []
        this.page.total = r.data.total
        this.loading = false
      })
    }
  },
  mounted() {
    this.handleGetDataInit()
    this.findData()
    this.handleGetUserType()
    this.handleGetLang()
  }
}
</script>

<style lang="less" scoped>
.toolbar {
    // margin-bottom: 20px;
    flex-shrink: 0;
}

.ivu-row {
    .ivu-col {
        margin-bottom: 15px;
    }
}

.layout-card{
  /deep/ .ivu-card-body{
    height: 100%;display:flex;flex-direction: column;
  }
}
</style>
